import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
    // 缓存原型上的push函数
const originPush = VueRouter.prototype.push
const originReplace = VueRouter.prototype.replace
    // 给原型对象上的push指定新函数函数
VueRouter.prototype.push = function(location, onComplete, onAbort) {
    // 判断如果没有指定回调函数, 通过call调用源函数并使用catch来处理错误
    if (onComplete === undefined && onAbort === undefined) {
        return originPush.call(this, location, onComplete, onAbort).catch(() => {})
    } else { // 如果有指定任意回调函数, 通过call调用源push函数处理
        originPush.call(this, location, onComplete, onAbort)
    }
}
VueRouter.prototype.replace = function(location, onComplete, onAbort) {
    if (onComplete === undefined && onAbort === undefined) {
        return originReplace.call(this, location, onComplete, onAbort).catch(() => {})
    } else {
        originReplace.call(this, location, onComplete, onAbort)
    }
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}



const routes = [{
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ("@/views/Home.vue"),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ("@/views/Login.vue"),
    },
    {
        path: '/wxbind',
        name: 'wxbind',
        component: () =>
            import ("@/components/common/wxbind.vue"),
    }, {
        path: '/bindWeixin',
        name: 'bindWeixin',
        component: () =>
            import ("@/views/bindWeixin.vue"),
    },
    {
        path: '/qrblank',
        name: 'qrblank',
        component: () =>
            import ("@/views/qrBlank.vue"),
    },

    {
        path: '/help',
        name: 'help',
        component: () =>
            import ("@/views/help.vue"),
    },
    {
        path: '/forget',
        name: 'forget',
        component: () =>
            import ("@/views/forget.vue"),
    },
    {
        path: '/editPassword',
        name: 'EditPassword',
        component: () =>
            import ("@/views/EditPassword.vue"),
    },

    {
        path: '/forgetPassword',
        name: 'ForgetPassword',
        component: () =>
            import ("@/views/ForgetPassword.vue"),
    },
    {
        path: '/second',
        name: 'second',
        component: () =>
            import ("@/views/second.vue"),
        redirect: '/second/tongzhi',
        children: [{
                path: 'tongzhi',
                name: 'tongzhi',
                component: () =>
                    import ("@/views/home/tongzhi.vue"),
            },
            {
                path: 'tongzhiDetail/:id',
                name: 'tongzhiDetail',
                component: () =>
                    import ("@/views/home/tongzhiDetail.vue"),
            },
            {
                path: 'keyanDetail/:id',
                name: 'keyanDetail',
                component: () =>
                    import ("@/views/home/keyanDetail.vue"),
            },
            {
                path: 'keyan',
                name: 'keyan',
                component: () =>
                    import ("@/views/home/keyan.vue"),
            },
            {
                path: 'peixun',
                name: 'peixun',
                component: () =>
                    import ("@/views/home/peixun.vue"),
            },
            {
                path: 'peixunDetail/:id',
                name: 'peixunDetail',
                component: () =>
                    import ("@/views/home/peixunDetail.vue"),
            },
            {
                path: 'jiaoyudongtai',
                name: 'jiaoyudongtai',
                component: () =>
                    import ("@/views/home/jiaoyudongtai.vue"),
            }, {
                path: 'jiaoyuDetail/:id',
                name: 'jiaoyuDetail',
                component: () =>
                    import ("@/views/home/jiaoyuDetail.vue"),
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ("@/views/Login.vue"),
    },
    {
        path: '/teacher',
        name: 'teacher',
        component: () =>
            import ("@/views/user/index.vue"),
        redirect: '/teacher/main',
        children: [{
            path: 'main',
            component: () =>
                import ('@/views/user/userMain.vue')
        }, {
            path: 'commonMoreDongtai',
            name: 'commonMoreDongtai',
            component: () =>
                import ('@/components/common/commonMoreDongtai.vue')

        }, {
            path: 'dongtaiDetail/:id',
            name: 'teacherDongtaiDetail',
            component: () =>
                import ('@/components/common/dongtaiDetail.vue')
        }, {
            path: 'commonMoreNotice',
            name: 'commonMoreNotice',
            component: () =>
                import ('@/components/common/commonMoreNotice.vue')

        }, {
            path: 'noticeDetail/:id',
            name: 'teacherNoticeDetail',
            component: () =>
                import ('@/components/common/noticeDetail.vue')
        }, {
            path: 'editUser',
            component: () =>
                import ('@/components/common/editUser.vue'),
            redirect: 'editUser/editInfo',
            children: [{
                path: 'editInfo',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editInfo.vue"),
            }, {
                path: 'editPsd',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editPsd.vue"),
            }, {
                path: "bindMobile",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindMobile.vue")
            }, {
                path: "bindWeixin",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindWeixin.vue")
            }]
        }, {
            ///ediProfile
            path: 'editProfile',
            name: 'editProfile',
            component: () =>
                import ('@/components/common/editProfile.vue'),
        }]
    },
    {
        path: '/student',
        name: 'student',
        component: () =>
            import ("@/views/student/index.vue"),
        redirect: '/student/main',
        children: [{
            path: 'main',
            component: () =>
                import ('@/views/student/studentMain.vue')
        }, {
            path: 'commonMoreDongtai',
            name: 'commonMoreDongtai',
            component: () =>
                import ('@/components/common/commonMoreDongtai.vue')

        }, {
            path: 'dongtaiDetail/:id',
            name: 'studentDongtaiDetail',
            component: () =>
                import ('@/components/common/dongtaiDetail.vue')
        }, {
            path: 'commonMoreNotice',
            name: 'commonMoreNotice',
            component: () =>
                import ('@/components/common/commonMoreNotice.vue')

        }, {
            path: 'noticeDetail/:id',
            name: 'studentNoticeDetail',
            component: () =>
                import ('@/components/common/noticeDetail.vue')
        }, {
            path: 'editUser',
            component: () =>
                import ('@/components/common/editUser.vue'),
            redirect: 'editUser/editInfo',
            children: [{
                path: 'editInfo',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editInfo.vue"),
            }, {
                path: 'editPsd',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editPsd.vue"),
            }, {
                path: "bindMobile",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindMobile.vue")
            }, {
                path: "bindWeixin",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindWeixin.vue")
            }]
        }]
    },
    {
        path: '/society',
        name: 'society',
        component: () =>
            import ("@/views/society/index.vue"),
        redirect: '/society/main',
        children: [{
            path: 'main',
            component: () =>
                import ('@/views/society/societyMain.vue')
        }, {
            path: 'editUser',
            component: () =>
                import ('@/components/common/editUser.vue'),
            redirect: 'editUser/editInfo',
            children: [{
                path: 'editInfo',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editInfo.vue"),
            }, {
                path: 'editPsd',
                name: 'editUser',
                component: () =>
                    import ("@/components/common/editPsd.vue"),
            }, {
                path: "bindMobile",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindMobile.vue")
            }, {
                path: "bindWeixin",
                name: 'editUser',
                component: () =>
                    import ("@/components/common/bindWeixin.vue")
            }]
        }]
    },
    {
        path: '/manager',
        name: 'manager',
        component: () =>
            import ("@/views/manager/index.vue"),
        redirect: '/manager/main',
        children: [{
                path: 'main',
                name: 'main',
                component: () =>
                    import ('@/views/manager/managerMain.vue')
            }, {
                path: 'moreTodo',
                name: 'moreTodo',
                component: () =>
                    import ('@/components/common/moreTodo.vue')

            }, {
                path: 'moreNotice',
                name: 'moreNotice',
                component: () =>
                    import ('@/components/common/moreNotice.vue')

            }, {
                path: 'noticeDetail/:id',
                name: 'managerNoticeDetail',
                component: () =>
                    import ('@/components/common/noticeDetail.vue')
            }, {
                path: 'editUser',
                component: () =>
                    import ('@/components/common/editUser.vue'),
                redirect: 'editUser/editInfo',
                children: [{
                    path: 'editInfo',
                    name: 'editUser',
                    component: () =>
                        import ("@/components/common/editInfo.vue"),
                }, {
                    path: 'editPsd',
                    name: 'editUser',
                    component: () =>
                        import ("@/components/common/editPsd.vue"),
                }, {
                    path: "bindMobile",
                    name: 'editUser',
                    component: () =>
                        import ("@/components/common/bindMobile.vue")
                }, {
                    path: "bindWeixin",
                    name: 'editUser',
                    component: () =>
                        import ("@/components/common/bindWeixin.vue")
                }]
            }, {
                path: 'dongtai',
                name: 'jiaoyuDongtai',
                component: () =>
                    import ('@/views/manager/dongtai.vue')
            },
            {
                path: 'addDongtai',
                name: 'jiaoyuDongtai',
                component: () =>
                    import ('@/views/manager/addDongtai.vue')
            }, {
                path: 'dongtaiDetail/:id',
                name: 'jiaoyuDongtai',
                component: () =>
                    import ('@/views/manager/dongtaiDetail.vue')
            }, {
                path: 'gonggao',
                name: 'gonggao',
                component: () =>
                    import ('@/views/manager/gonggao.vue')
            },
            {
                path: 'addGonggao',
                name: 'gonggao',
                component: () =>
                    import ('@/views/manager/addGonggao.vue')
            }, {
                path: 'gonggaoDetail/:id',
                name: 'gonggao',
                component: () =>
                    import ('@/views/manager/gonggaoDetail.vue')
            }, {
                path: 'xiaoyuanDongtai',
                name: 'xiaoyuanDongtai',
                component: () =>
                    import ('@/views/manager/xiaoyuanDongtai.vue')
            },
            {
                path: 'addXiaoyuanDongtai',
                name: 'xiaoyuanDongtai',
                component: () =>
                    import ('@/views/manager/addXiaoyuanDongtai.vue')
            }, {
                path: 'xiaoyuanDongtaiDetail/:id',
                name: 'xiaoyuanDongtai',
                component: () =>
                    import ('@/views/manager/xiaoyuanDongtaiDetail.vue')
            }, {
                path: 'managerTongzhi',
                name: 'managerTongzhi',
                component: () =>
                    import ('@/views/manager/managerTongzhi.vue')
            },
            {
                path: 'addManagerTongzhi',
                name: 'managerTongzhi',
                component: () =>
                    import ('@/views/manager/addManagerTongzhi.vue')
            }, {
                path: 'managerTongzhiDetail/:id',
                name: 'managerTongzhi',
                component: () =>
                    import ('@/views/manager/managerTongzhiDetail.vue')
            }
        ]
    },
]

const createRouter = () => new VueRouter({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    base: 'skynotice',
    routes: routes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

export default router